import { render, staticRenderFns } from "./plan-card.vue?vue&type=template&id=f579b1fa"
import script from "./plan-card.vue?vue&type=script&lang=js"
export * from "./plan-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports